<div class="modal no-print" *ngIf="show" [class.is-open]="show">
  <div class="modal__overlay bg-modal {{ bgStyle }}">
    <div
      class="modal__container"
      *ngIf="!empty"
      aria-modal="true"
      role="dialog"
      [attr.aria-labelledby]="'Kontaktoplysninger.Overskrift' | tekstresource"
    >
      <main class="modal__content">
        <ng-content select="[bom-fullpage-main]"></ng-content>
      </main>
      <ng-content select="[bom-fullpage-footer]"></ng-content>
    </div>
  </div>
</div>
